import { createSelector } from 'reselect';
import { SUCCEEDED, FAILED } from 'ContentUtils/constants/RequestStatus';
import * as webInteractiveSelectors from './webInteractives';
export const getCta = (state, props) => state.resources.ctas.ctas[props.guid];
export const getCtas = state => state.resources.ctas.ctas;
export const getCtaFetchStatus = (state, props) => state.resources.ctas.requestStatus[props.guid];
export const getIsCtaFetchDone = (state, props) => {
  if (!props.guid) return true;
  const fetchStatus = getCtaFetchStatus(state, props);
  return fetchStatus === SUCCEEDED || fetchStatus === FAILED;
};
const createCtaOptionsSelector = selector => createSelector([selector], resources => {
  return Object.keys(resources).map(guid => {
    const option = resources[guid];
    const {
      name
    } = option;
    const defaultCta = option.ctaInfo.filter(_cta => {
      return _cta.isDefault;
    })[0] || option.ctaInfo[0] || {};
    const {
      image
    } = defaultCta;
    return {
      value: guid,
      text: name,
      image
    };
  });
});
export const getDefaultCtasOptions = createCtaOptionsSelector(getCtas);
export const makeGetSelectedCtaImage = (ctaSelector = getCta) => {
  return createSelector([ctaSelector], cta => {
    if (!cta) return null;
    const defaultCta = cta.ctaInfo.filter(_cta => {
      return _cta.isDefault;
    })[0] || cta.ctaInfo[0] || {};
    return defaultCta.image;
  });
};
const checkIsWebInteractive = guid => !isNaN(Number(guid));
export const makeGetCtaFieldData = () => {
  const getSelectedCtaImage = makeGetSelectedCtaImage();
  return (state, props) => {
    const {
      guid,
      isInEmail
    } = props;
    const isWebInteractive = checkIsWebInteractive(guid);
    if (isWebInteractive) {
      const id = Number(guid);
      const cta = webInteractiveSelectors.getWebInteractiveInLegacyShape(state, {
        id,
        isInEmail
      });
      const selectedCtaImage = cta ? cta.ctaInfo[0].image : null;
      const hasLoaded = webInteractiveSelectors.getIsWebInteractiveFetchDone(state, {
        id
      });
      return {
        cta,
        selectedCtaImage,
        hasLoaded
      };
    }
    const stringGuid = guid;
    const cta = getCta(state, {
      guid: stringGuid
    });
    const selectedCtaImage = getSelectedCtaImage(state, {
      guid: stringGuid
    });
    const hasLoaded = getIsCtaFetchDone(state, {
      guid: stringGuid
    });
    return {
      cta,
      selectedCtaImage,
      hasLoaded
    };
  };
};